import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
`

export const GreenContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors.primary};
  opacity: 0.96;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2% 0;
`

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  max-height: 300px;
  width: 50vw;
  max-width: 320px;
`

export const SaveArea = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;

  @media (max-width: 410px) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`

export const SwitchArea = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 410px) {
    width: 100%;
  }
`

export const ButtonArea = styled.div`
  width: 40%;
  display: flex;
  cursor: pointer;

  & > :nth-child() {
    color: ${colors.primary};
  }

  @media (max-width: 410px) {
    width: 100%;
    justify-content: center;
  }
`
